module.exports = __webpack_public_path__ + "img/stt-done.65ce756e.png";